import {EntryConvertResponse} from "../../infra/api/service/entry_api_convert";
import moment from "moment";

export class Entry {
    public static from(from: EntryConvertResponse): Entry {
        return new Entry(
            from.customerID,
            from.projectID,
            from.createdAt,
        )
    }

    constructor(public readonly customerID: string,
                public readonly projectID: string,
                public readonly createdAt: Date,
    ) {
    }

    public getCreatedAtString(): string {
        return moment(this.createdAt).format("YYYY-MM-DD(ddd)");
    }
}

export class EntryCountByProject {
    public static from(from: EntryCountByProject): EntryCountByProject {
        return new EntryCountByProject(
            from.projectID,
            from.count,
        )
    }


    constructor(public readonly projectID: string,
                public readonly count: number | Long,
    ) {
    }

}



// WEBPACK FOOTER //
// ./src/domain/model/entry.ts